import React from 'react';
import apiClient from '../../utils/api';

const WithdrawalsTab = ({ withdrawals, onRefresh }) => {
    const handleStatusUpdate = async (id, status) => {
        if (!window.confirm(`Mark this withdrawal as ${status}?`)) return;
        try {
            await apiClient.put(`/admin/withdrawals/${id}`, { status });
            alert("Updated successfully");
            onRefresh();
        } catch (err) {
            alert("Failed to update");
        }
    };

    return (
        <div className="admin-tab-content">
            <h2>Withdrawal Requests</h2>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>Amount</th>
                        <th>Bank Details</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {withdrawals.map(w => (
                        <tr key={w.id}>
                            <td style={{ textAlign: 'left', padding: '10px' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>{w.userName}</div>
                                <div style={{ fontSize: '12px', color: '#555' }}>Email: {w.userEmail}</div>
                                <div style={{ fontSize: '12px', color: '#555' }}>Mobile: {w.userPhone}</div>
                            </td>
                            <td style={{ fontWeight: 'bold' }}>₹{w.amount}</td>
                            <td>
                                {/* 1. Show UPI if it exists */}
                                {w.bankDetails?.upiId && (
                                    <div style={{ color: '#1976d2', fontWeight: 'bold', marginBottom: '8px', borderBottom: w.bankDetails?.accountNo ? '1px solid #eee' : 'none', pb: '5px' }}>
                                        UPI: {w.bankDetails.upiId}
                                    </div>
                                )}

                                {/* 2. Show Bank Details if they exist */}
                                {w.bankDetails?.accountNo && (
                                    <div style={{ fontSize: '12px', color: '#333', lineHeight: '1.4' }}>
                                    <div style={{ fontWeight: '600' }}>{w.bankDetails.name}</div>
                                    <div>A/C: {w.bankDetails.accountNo}</div>
                                    <div>IFSC: {w.bankDetails.ifsc}</div>
                                    </div>
                                )}

                                {/* 3. Fallback if both are empty */}
                                {!w.bankDetails?.upiId && !w.bankDetails?.accountNo && (
                                    <span style={{ color: '#999', fontStyle: 'italic' }}>No payment info</span>
                                )}
                            </td>
                            <td><span className={`status-badge ${w.status}`}>{w.status}</span></td>
                            <td>
                                {w.status === 'pending' && (
                                    <>
                                        <button onClick={() => handleStatusUpdate(w.id, 'completed')} className="btn-approve">Mark Paid</button>
                                        <button onClick={() => handleStatusUpdate(w.id, 'rejected')} className="btn-reject">Reject</button>
                                    </>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default WithdrawalsTab;